export const ProductTileTagsLoading = () => {
  return (
    <div className="flex flex-wrap items-center gap-2 py-1">
      {[...Array(5)].map((_, index) => (
        <div
          key={index}
          className="bg-greyscale-background h-6 w-16 animate-pulse rounded-full"
        />
      ))}
    </div>
  );
};
